import { TokenInterceptorService } from './SharedModule/interceptor/token.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfigurationsService } from './services/configurations.service';
import { NewLoaderComponent } from './SharedModule/components/new-loader/new-loader.component';
import { LoaderInterceptor } from './SharedModule/interceptor/Loader.interceptor';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

const loadConfig = (service: ConfigurationsService) => {
  return () => {
    return service.loadConfigurations();
  };
};

@NgModule({
  declarations: [AppComponent, NewLoaderComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    // Provide MatDialog/MatSnackBar at the ROOT injector so the app-wide
    // ConfirmDialogService and ToastService (providedIn: 'root') can use them.
    MatDialogModule,
    MatSnackBarModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    ConfigurationsService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfig,
      multi: true,
      deps: [ConfigurationsService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
